import { render, staticRenderFns } from "./ProductSolutions.vue?vue&type=template&id=604d52bc&scoped=true&"
import script from "./ProductSolutions.vue?vue&type=script&lang=js&"
export * from "./ProductSolutions.vue?vue&type=script&lang=js&"
import style0 from "./ProductSolutions.vue?vue&type=style&index=0&id=604d52bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604d52bc",
  null
  
)

export default component.exports